import React, { Fragment, useContext, useEffect, useState } from "react";
import propTypes from "prop-types";

import { api, LaneAllocationRule, LaneAllocationRuleTypes, RequestStatus } from "../../../../logic/api";

import LaneAllocationRuleList from "./LaneAllocationRuleList";
import Dialog from "@mui/material/Dialog";
import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { LaneAllocationRuleProducts } from "./ruleListItems/LaneAllocationRuleProducts";
import { SessionContext } from "../../../../utility/useSession";
import { ProgressView } from "../../../../components/notifications/progress/ProgressView";
import ErrorDialog from "../../../../components/notifications/errorDialog/ErrorDialog";
import AlertDialog from "../../../../components/notifications/alertDialog/AlertDialog";
import { LaneAllocationRulePackages } from "./ruleListItems/LaneAllocationRulePackages";
import { LaneAllocationRuleShortStay } from "./ruleListItems/LaneAllocationRuleShortStay";
import { LaneAllocationRuleLongStay } from "./ruleListItems/LaneAllocationRuleLongStay";
import ConfirmationDialog from "../../../../components/notifications/confirmationDialog/ConfirmationDialog";
import { useTranslation } from "react-i18next";

const LaneAllocationView: React.FunctionComponent<{
    show: boolean;
    onClose: () => void;
}> = (props) => {
    const save = api.hooks.allocationRules.save();
    const list = api.hooks.allocationRules.list();
    const session = useContext(SessionContext);
    const { t } = useTranslation()
    const [rules, setRules] = useState<LaneAllocationRule[] | null>();
    const [didSave, setDidSave] = useState<boolean>(false);
    const [showConfirmErr, setShowConfirmErr] = useState<boolean>(false);
    const [showErr, setShowErr] = useState<boolean>(false);
    const [confirmErr, setConfirmErr] = useState<string | null>();
    const [err, setErr] = useState<string | null>();
    const [dirty, setDirty] = useState(false);

    useEffect(() => {
        if (props.show == true) {
            list.send(session.current.context, {
                includeInactive: true,
            }, (rules) => {

                console.warn(rules);
                orderByPriority(rules);
                setRules(rules);
            });
        }
    }, [props.show]);

    const orderByPriority = (rules: LaneAllocationRule[] | null) => {
        rules?.sort((a, b) => parseFloat(`${a.priority}`) - parseFloat(`${b.priority}`));
    }

    const saveAllChanges = (skipValidation: boolean) => {
        const saveRules = rules ?? [];

        if (skipValidation != true) {
            let invalidCount = 0;
            const priorities: number[] = [];
            for (const rule of saveRules) {
                if (rule.active != false && rule.deleted != true) {
                    if (priorities.indexOf(rule.priority) != -1) {
                        setShowErr(true);
                        setErr(t("errors.sameRulePriority", { rule: rule.priority }));
                        return;
                    }
                    priorities.push(rule.priority);
                    if (rule.type == LaneAllocationRuleTypes.packages) {
                        if ((rule.packageCodeRef ?? "").length == 0 || rule.location == null) {
                            invalidCount += 1;
                        }
                    } else if (rule.type == LaneAllocationRuleTypes.products) {
                        if ((rule.productCode ?? "").length == 0 || rule.location == null) {
                            invalidCount += 1;
                        }
                    } else if (rule.type == LaneAllocationRuleTypes.shortStays) {
                        const duration = parseInt(`${rule.duration}`);
                        if (isNaN(duration) || duration <= 0 || rule.location == null) {
                            invalidCount += 1;
                        }
                    } else if (rule.type == LaneAllocationRuleTypes.longStays) {
                        const duration = parseInt(`${rule.duration}`);
                        if (isNaN(duration) || duration <= 0 || rule.location == null) {
                            invalidCount += 1;
                        }
                    }
                }
            }
            if (invalidCount > 0) {
                setShowConfirmErr(true);
                setConfirmErr(t("errors.incompleteRules", { count: invalidCount }));
                return;
            }
        }
        setShowConfirmErr(false);
        setConfirmErr(null);

        save.send(session.current.context, {
            rules: saveRules
        }, (result) => {
            if (result != null) setDidSave(true);
        });
    };
    const onCreate = (rule: LaneAllocationRule) => {
        const newRules = [...(rules ?? [])];
        orderByPriority(newRules);

        const tmpRules = newRules.filter((f) => f.active != false && f.deleted != true);
        orderByPriority(tmpRules);
        console.log(tmpRules);
        if (tmpRules.length == 0) {
            rule.priority = 1;
        } else {
            rule.priority = parseInt(`${tmpRules[tmpRules.length - 1].priority}`) + 1;
        }
        console.log(rule.priority);
        newRules.push(rule);
        setRules(newRules);
        setDirty(true);
    };
    const onChange = (rule: LaneAllocationRule) => {
        const updatedRules = [...(rules ?? [])];
        console.warn(rule);
        orderByPriority(updatedRules);
        setRules(updatedRules);
        setDirty(true);
    };


    return <Dialog
        open={props.show}
        onClose={() => props.onClose()}
        maxWidth={"lg"}
        fullWidth={true}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
    >
        <DialogTitle>{t("kmos.labels.laneAllocationRules")}</DialogTitle>
        <DialogContent>
            <ConfirmationDialog title={t("kmos.labels.validationErrors")} message={confirmErr ?? ""} show={showConfirmErr} onClose={(r) => {
                setShowConfirmErr(false);
                if (r == true) {
                    saveAllChanges(true);
                }

            }}></ConfirmationDialog>
            <AlertDialog title={t("kmos.labels.error")} message={err ?? ""} show={showErr} onClose={() => {
                setShowErr(false);
            }}></AlertDialog>
            <ErrorDialog err={list.err}></ErrorDialog>
            <ProgressView status={save.status}>
                <ProgressView status={list.status}>
                    <AlertDialog title={t("kmos.labels.laneAllocationRules")} message={t("general.changesSaved")} show={didSave} onClose={() => {
                        setDidSave(false);
                        setDirty(false);
                        // props.onClose();
                    }}></AlertDialog>
                    <div>
                        <h2 style={{ fontSize: 14 }}>{t("booking.labels.products")}</h2>
                        <LaneAllocationRuleList type={LaneAllocationRuleTypes.products} rules={rules}
                            onCreate={(r) => onCreate(r)}

                            onChange={(r) => onChange(r)}
                            renderItem={(rule) => {
                                return <LaneAllocationRuleProducts rule={rule} onChange={(r) => onChange(r)}></LaneAllocationRuleProducts>
                            }}></LaneAllocationRuleList>

                        <h2 style={{ fontSize: 14 }}>{t("kmos.labels.packages")}</h2>
                        <LaneAllocationRuleList
                            type={LaneAllocationRuleTypes.packages} rules={rules}
                            onCreate={(r) => onCreate(r)}

                            onChange={(r) => onChange(r)}
                            renderItem={(rule) => {
                                return <LaneAllocationRulePackages rule={rule} onChange={(r) => onChange(r)}></LaneAllocationRulePackages>
                            }}></LaneAllocationRuleList>

                        <h2 style={{ fontSize: 14 }}>{t("kmos.labels.shortStay")}</h2>
                        <LaneAllocationRuleList type={LaneAllocationRuleTypes.shortStays} rules={rules}
                            onCreate={(r) => onCreate(r)}

                            onChange={(r) => onChange(r)}
                            renderItem={(rule) => {
                                return <LaneAllocationRuleShortStay rule={rule} onChange={(r) => onChange(r)}></LaneAllocationRuleShortStay>
                            }}></LaneAllocationRuleList>

                        <h2 style={{ fontSize: 14 }}>{t("kmos.labels.longStay")}</h2>
                        <LaneAllocationRuleList type={LaneAllocationRuleTypes.longStays} rules={rules}
                            onCreate={(r) => onCreate(r)}

                            onChange={(r) => onChange(r)}
                            renderItem={(rule) => {
                                return <LaneAllocationRuleLongStay rule={rule} onChange={(r) => onChange(r)}></LaneAllocationRuleLongStay>
                            }}></LaneAllocationRuleList>
                    </div>
                </ProgressView>
            </ProgressView>
        </DialogContent>
        <DialogActions>
            {(list.status != RequestStatus.loading || save.status != RequestStatus.loading) &&
                (<Fragment>
                    <Button onClick={() => {
                        if (dirty) {
                            if (confirm(t("errors.closeWithoutSaving")) != true) {
                                return;
                            }
                            setDirty(false);
                        }
                        props.onClose();
                    }}
                        color="primary">{t("general.close")}</Button>
                    {rules != null && (
                        <Button onClick={() => saveAllChanges(false)}
                            color="primary"><b>{t("general.saveChanges")}</b></Button>
                    )}
                </Fragment>)
            }

        </DialogActions>
    </Dialog>
}

LaneAllocationView.propTypes = {
    show: propTypes.bool.isRequired,
    onClose: propTypes.func.isRequired,
}

export default LaneAllocationView;
